import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import UserApi from "../../api/user";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";

// types
import { PaymentSummaryResponse } from "../../types/api/user";

// ui components
import Card from "../Common/Card";
import InputSkeletonGroup from "../Common/Loaders/InputSkeleton";
import PaymentDetails from "./PaymentDetails";

const PaymentSummary = () => {
  const [payments, setPayments] = useState<PaymentSummaryResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getPayments = async () => {
      const response = await UserApi.GetPaymentSummary();
      setPayments(response);
      setLoading(false);
    };

    getPayments();
  }, []);

  const hasPayments = !loading && !!payments?.disbursementDate;

  return (
    <div className="payment-summary col-flex-1">
      <Card
        title={i18n.t("PAGES.DASHBOARD.PAYMENT_SUMMARY_HEADER")}
        titleWeight="strong"
        fullWidth
        bodyPadding="all-sides"
        footerProps={{ align: "center", divided: true, padding: "tight" }}
        footer={
          !loading && (
            <Link
              to={ROUTES.PAYMENTS_DISBURSEMENT_HISTORY.INDEX}
              className="btn btn-text btn-narrow"
            >
              View Payment History
            </Link>
          )
        }
      >
        {loading && <InputSkeletonGroup numInputs={4} />}

        {hasPayments && <PaymentDetails payments={payments} />}

        {!loading && !hasPayments && <p className="mb-0">No payments could be found</p>}
      </Card>
    </div>
  );
};

export default PaymentSummary;